import { ServerFetch } from '../main-model'

export default class ProductReplaceModel extends ServerFetch {
    getProductReplaceBy = (data) => this.authFetch({
        url: 'product-replace/getProductReplaceBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}